import * as React from 'react';
import set from 'lodash/set';
import get from 'lodash/get';
import { columnName, tableName } from '../../case-data-model';

export function caseSignReadonly<P extends object>() {

  return (WrappedComponent: React.ComponentClass<P> | React.FC<P>) => {

    return class extends React.PureComponent<P> {
      public render() {
        const {
          readOnly,
          currentUser,
          rowEntity,
          value
        } = this.props as any;

        let readOnlyOverride = undefined;
        const modifiedProps: P = {...this.props as any};
        const rowUser = get(rowEntity, `${columnName[tableName.signature].signaturePerson}[0].value`);
        const signatureType = get(rowEntity, `${columnName[tableName.signature].signatureType}[0].value`);

        if(!signatureType){
          readOnlyOverride = true;
        }

        // user > 0, but not current user on row
        if(rowUser && rowUser !== currentUser.value){
          readOnlyOverride = true;
        }

        // date and no user: hide (awaiting name as default value from server)
        if(value && !rowUser) {
          readOnlyOverride = true;
        }

        // domain criteria, typically effect of beeing a case administrator
        if(readOnly === false) {
          readOnlyOverride = false;
        }

        // signaturetype, date and user === current user: show
        // case admin for others rows: do nothing (let server provide readonly for unsign)
        if (readOnlyOverride !== undefined) {
          set(modifiedProps as P, 'readOnly', readOnlyOverride);
        }

        return <WrappedComponent { ...modifiedProps } /> ;
      }
    };
  };
}
